import { Box, Stack, Typography } from '@mui/material'

export default function Value() {
  return (
    <Stack className="py-10 container lg:px-[10%] max-w-6xl flex flex-col items-center justify-center">
      <h3 className="heading-2 min-w-[150px] text-center mb-5">VALUE</h3>
      <h4>私たちの価値観・行動指針</h4>
      <Stack className="my-5 hidden md:flex">
        <Box
          component="img"
          src="/static/about-value.png"
          alt="about-value"
          className="object-contain w-full h-full"
        ></Box>
      </Stack>
      <Stack className="md:hidden">
        <Box
          component="img"
          src="/static/about-value-sp.png"
          alt="about-value"
          className="object-contain w-full h-full"
        ></Box>
        <Box className="px-4">
          <Stack className="gap-2 mt-10">
            <Typography className="text-[#1d5dba] font-semibold text-lg">
              対話
            </Typography>
            <Typography className="font-light">
              私たちは、遊明性のある対話を重視します。心理的安会性を確保し、意見やアイデアを自由に共有することで、互いに理解し合うことを目指します。
            </Typography>
          </Stack>
          <Stack className="gap-2 mt-10">
            <Typography className="text-[#1d5dba] font-semibold text-lg">
              信頼と敬意
            </Typography>
            <Typography className="font-light">
              私たちは、互いに信頼し尊重し合うことを重視します。多様性を活かし合い、個々の能力を最大限に引き出します。
            </Typography>
          </Stack>
          <Stack className="gap-2 mt-10">
            <Typography className="text-[#1d5dba] font-semibold text-lg">
              挑戦
            </Typography>
            <Typography className="font-light">
              私たちは、新しいことに挑戦する精神を持ち続けます。失敗を恐れず、常に学び続ける姿勢を大切にし、革新を追求します。
            </Typography>
          </Stack>
          <Stack className="gap-2 mt-10">
            <Typography className="text-[#1d5dba] font-semibold text-lg">
              誠実
            </Typography>
            <Typography className="font-light">
              私たちは、道標的、倫理的に誠実であることを重視します。
              社全体の利益を考え、常に正直で信頼に値する行動を取ります。
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  )
}
